import { IDropdownOption } from "@fluentui/react";
import { Formik, FormikErrors } from "formik";
import {
  Calendar,
  Callout,
  Checkbox,
  DayOfWeek,
  DefaultButton,
  DirectionalHint,
  Dropdown,
  DropdownMenuItemType,
  FocusTrapZone,
  IBasePickerSuggestionsProps,
  IPersonaProps,
  ISelectableOption,
  IStackTokens,
  NormalPeoplePicker,
  PrimaryButton,
  Stack,
  TextField,
  Toggle,
  values,
} from "office-ui-fabric-react";
import * as React from "react";
import { ICCTVImage, ICCTVImageVM, IDataCenter, IFloorVM } from "../../../vm";
import CustomDrawer from "../../common/CustomDrawer";
import { ToastContext } from "../../common/ToastProvider";
import * as yup from "yup";
import {
  addCCTVImage,
  updateCCTVImage,
  getAllCustomers,
  getCustomers,
} from "../../../services/customers/CustomerService";
import {
  getFileByBase64,
  getFileTypeErrorMessage,
  uploadFile,
  validateFileType,
} from "../../../services/UtilService";
import Icon from "@mdi/react";
import { mdiClose, mdiCloseCircle } from "@mdi/js";
import { THEME } from "../../../utils/Styles";
import ImageCropper from "./ImageCropper";
import moment from "moment";
import {
  DayPickerStrings,
  FILE_UPLOAD_CONFIG,
  FILE_UPLOAD_MODULES,
} from "../../common/Constants";

const cctvImageSchema = yup.object().shape({
  datacenterId: yup.string().required("required"),
  floorId: yup.string().required("required"),
  image: yup.string().required("required"),
});

let calendarButtonElement: HTMLElement;
export interface ManageCCTVImageProps {
  data?: ICCTVImage;
  handleLoading: any;
  handleDialogClose: any;
  customerId: string;
  dataCenters: IDataCenter[];
  dataCenterOptions: IDropdownOption[];
  date: Date;
}

const ManageCCTVImage: React.FC<ManageCCTVImageProps> = ({
  data,
  handleDialogClose,
  handleLoading,
  customerId,
  dataCenterOptions,
  dataCenters,
  date,
}) => {
  //state
  const [state, setState] = React.useState({
    cctvImage: {
      datacenterId: "none",
      customerIds: [customerId],
      // customerId: customerId,
      date: new Date(date),
      floorId: "none",
      image: "",
      description: "",
      deletedImage: "",
      isForAll: false,
      customers: [],
      ...data,
    },
    dataCenters: [...dataCenters],
    dataCenterOptions: [...dataCenterOptions.filter((ele) => ele.key != "all")],
    allFloorsDropdownList: [],
    selectedImage: undefined,
    manageImageCropDialog: {
      isOpen: false,
      data: undefined,
    },
    showCallender: false,
  } as {
    cctvImage: ICCTVImageVM;
    dataCenters: IDataCenter[];
    dataCenterOptions: IDropdownOption[];
    allFloorsDropdownList: IDropdownOption[];
    selectedImage?: File;
    manageImageCropDialog: {
      isOpen: boolean;
      data?: any;
    };
    showCallender: boolean;
  });

  // file upload config
  const fileUploadConfig = FILE_UPLOAD_CONFIG[FILE_UPLOAD_MODULES.CCTV_IMAGE];

  //custom hooks
  const { showToast } = React.useContext(ToastContext);

  const wrapStackTokens: IStackTokens = { childrenGap: 16 };

  React.useEffect(() => {
    const asyncFunc = async () => {
      if (data) {
        let datacenter = dataCenters.find(
          (ele) => ele._id === state.cctvImage.datacenterId
        );
        if (datacenter) {
          let options: IDropdownOption[] = [];
          const floorByBuilding: {
            [Key: string]: IFloorVM[];
          } = datacenter.floors.reduce((acc: any, d) => {
            if (acc[d.buildingId] == null) {
              acc[d.buildingId] = [];
            }
            let buildingName =
              datacenter?.buildings.find((ele) => ele._id === d.buildingId)
                ?.name || "";
            acc[d.buildingId].push({
              buildingId: d.buildingId,
              buildingName,
              floorId: d._id,
              floorName: d.name,
            });
            return acc;
          }, {});
          let temp = Object.keys(floorByBuilding);
          temp.forEach((d, index) => {
            options.push({
              key: d,
              text: floorByBuilding[d][0].buildingName,
              itemType: DropdownMenuItemType.Header,
            });
            floorByBuilding[d].forEach((f) => {
              options.push({
                key: f.floorId,
                text: f.floorName,
                data: { buildingName: f.buildingName },
              });
            });
            if (temp.length != index + 1) {
              options.push({
                key: "divider_1",
                text: "-",
                itemType: DropdownMenuItemType.Divider,
              });
            }
          });
          const tempCCTV = { ...state.cctvImage };
          const result = await getCustomers([
            customerId,
            ...(state.cctvImage?.customerIds as any),
          ]);
          if (result && result.success) {
            tempCCTV.customers = result.data.map((d) => {
              return {
                text: d.name,
                secondaryText: d.regSapNo,
                id: d._id as string,
              };
            });
          }
          setState({
            ...state,
            allFloorsDropdownList: options,
            cctvImage: tempCCTV,
          });
        }
      } else {
        const tempCCTV = { ...state.cctvImage };
        const result = await getCustomers([customerId]);
        if (result && result.success) {
          tempCCTV.customers = result.data.map((d) => {
            return {
              text: d.name,
              secondaryText: d.regSapNo,
              id: d._id as string,
            };
          });
        }
        setState({
          ...state,
          cctvImage: tempCCTV,
        });
      }
    };
    asyncFunc();
  }, []);

  const closeAddDialog = (data?: ICCTVImage) => {
    handleDialogClose(data);
  };

  const handleFileChange = (files: any) => {
    if (files && files.length > 0) {
      // Validate file type
      const isValidType = validateFileType(
        files[0],
        fileUploadConfig.acceptedFileTypes
      );

      if (!isValidType) {
        showToast(
          getFileTypeErrorMessage(fileUploadConfig.fileTypeDescription),
          "error"
        );
      }
      console.log("f", files[0]);

      if (isValidType) {
        setState({
          ...state,
          selectedImage: files[0],
          manageImageCropDialog: { isOpen: true, data: files[0] },
        });
      } else {
        setState({
          ...state,
          selectedImage: files[0],
        });
      }
    } else {
      showToast("Please select a file to import", "error");
    }
  };

  const onCloseImageCropDialog = async (data: any) => {
    if (data) {
      let image = await getFileByBase64(data, "newFile.jpeg");
      setState({
        ...state,
        manageImageCropDialog: { isOpen: false, data: undefined },
        selectedImage: image,
      });
    } else {
      setState({
        ...state,
        manageImageCropDialog: { isOpen: false, data: undefined },
      });
    }
  };

  const uploadImage = async (fileName: string, file: File) => {
    handleLoading();
    // let result = await getSignedUrl([fileName], file.type);
    // let a={...file as any}
    // a["name"]=fileName;
    let result = await uploadFile(file);
    handleLoading();
    if (result.success) {
      return result?.data?.fileName || "";
      // return fileName;
    } else {
      showToast(result.message || `Error while uploading image`, "error");
    }
    return undefined;
  };

  const onRenderOption = (option?: ISelectableOption): JSX.Element => {
    if (!option) return <div />;
    return (
      <div className="d-flex">
        {/* {!option.itemType && <Icon path={mdiFloorPlan} size={0.8} />} */}
        <span style={{ marginLeft: option.itemType ? "0px" : "12px" }}>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    if (!options) return <div />;
    const option = options[0];

    return (
      <div>
        <span>
          {option.data
            ? option.data.buildingName + "-" + option.text
            : option.text}
        </span>
      </div>
    );
  };

  const deleteImage = (deletedImage: string, values: any) => {
    setState({
      ...state,
      cctvImage: {
        ...values,
        deletedImage,
        imageUrl: "",
      },
    });
  };

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    // suggestionsHeaderText: "Suggested Card holders",
    noResultsFoundText: "No Customer found",
  };

  const onFilterChanged = async (
    filterText: string,
    tagList?: IPersonaProps[]
  ): Promise<IPersonaProps[]> => {
    if (filterText && filterText.length >= 3) {
      let result = await getAllCustomers({
        search: filterText,
        offset: 0,
        limit: 12,
      });
      if (result?.success) {
        const cardHolderTag: IPersonaProps[] = [];
        // let tempcardHoldersList = result.data;

        setState({ ...state });

        result?.data.forEach((item: any) => {
          cardHolderTag.push({
            // key: item._id as string,
            // name: item.firstName + " " + item.lastName,
            // data:  item as IPersonaProps
            text: item.name,
            secondaryText: item.regSapNo,
            id: item._id,
          });
        });
        return cardHolderTag;
      } else {
        return [];
      }
    }
    return [];
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  return (
    <React.Fragment>
      <CustomDrawer
        title={state.cctvImage._id ? "Update CCTV Image" : "Add CCTV Image"}
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            enableReinitialize
            initialValues={state.cctvImage}
            // validationSchema={cctvImageSchema}
            validate={(values) => {
              let errors: FormikErrors<ICCTVImage> = {};
              if (!values.datacenterId || values.datacenterId === "none") {
                errors.datacenterId = "Required";
              }
              if (!values.floorId || values.floorId === "none") {
                errors.floorId = "Required";
              }
              if (!values.image && !state.selectedImage) {
                errors.image = "Required";
              } else if (state.selectedImage !== undefined) {
                const isValidType = validateFileType(
                  state.selectedImage,
                  fileUploadConfig.acceptedFileTypes
                );

                if (!isValidType) {
                  errors.image = getFileTypeErrorMessage(
                    fileUploadConfig.fileTypeDescription
                  );
                }
              }
              return errors;
            }}
            onSubmit={async (values: ICCTVImage, { setSubmitting }) => {
              let obj = { ...values };
              let result;
              if (state.selectedImage) {
                let name =
                  customerId +
                  "-" +
                  new Date().getTime() +
                  "-" +
                  state.selectedImage.name.toLowerCase().replace(/ /g, "");
                let fileName = await uploadImage(name, state.selectedImage);
                if (fileName) {
                  obj.image = fileName;
                } else return;
              }
              if (obj.isForAll === true) {
                obj.customerIds = [];
              }
              handleLoading();
              if (state.cctvImage._id) {
                result = await updateCCTVImage(obj);
              } else {
                result = await addCCTVImage(obj);
              }
              handleLoading();
              if (result.success) {
                closeAddDialog(result.data);
              } else {
                showToast(
                  result.message ||
                    `Error while ${
                      state.cctvImage._id ? "updating" : "adding"
                    } CCTV Image`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={wrapStackTokens} className="pt-16">
                  <Stack.Item grow={1} className="mb-30">
                    <div
                      ref={(calendarBtn) =>
                        (calendarButtonElement = calendarBtn!)
                      }
                    >
                      <DefaultButton
                        text={
                          !values.date
                            ? "Select a month"
                            : moment(values.date).format("MMM-YYYY")
                        }
                        onClick={() =>
                          setState({ ...state, showCallender: true })
                        }
                        className="month-picker-btn w-100"
                      />
                    </div>
                    {state.showCallender && (
                      <Callout
                        isBeakVisible={false}
                        gapSpace={0}
                        doNotLayer={false}
                        target={calendarButtonElement}
                        directionalHint={DirectionalHint.bottomLeftEdge}
                        onDismiss={() => closeCallender()}
                        setInitialFocus
                      >
                        <FocusTrapZone
                          firstFocusableSelector="ms-DatePicker-day--today"
                          isClickableOutsideFocusTrap
                        >
                          <Calendar
                            // eslint-disable-next-line react/jsx-no-bind
                            onSelectDate={(date: Date | null | undefined) => {
                              setFieldValue("date", date);
                              setState({
                                ...state,
                                showCallender: false,
                              });
                            }}
                            onDismiss={() => closeCallender()}
                            isMonthPickerVisible={true}
                            value={new Date(values.date)}
                            firstDayOfWeek={DayOfWeek.Sunday}
                            strings={DayPickerStrings}
                            isDayPickerVisible={false}
                            highlightCurrentMonth={false}
                            highlightSelectedMonth={true}
                            showMonthPickerAsOverlay={false}
                            showGoToToday={false}
                            maxDate={new Date()}
                          />
                        </FocusTrapZone>
                      </Callout>
                    )}
                  </Stack.Item>
                  <Stack.Item>
                    <div className="ms-Grid p-0">
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6 ms-xl6 ms-xxl6 custom-dropdown mb-30">
                          <Dropdown
                            className="w-100"
                            placeholder="Select a Datacenter"
                            label="Datacenter"
                            selectedKey={values.datacenterId}
                            // styles={{ dropdown: { width: 200 } }}
                            options={state.dataCenterOptions}
                            onBlur={handleBlur}
                            errorMessage={
                              errors.datacenterId && touched.datacenterId
                                ? errors.datacenterId
                                : ""
                            }
                            onChange={(e, v: IDropdownOption | undefined) => {
                              if (v) {
                                let datacenter = state.dataCenters.find(
                                  (ele) => ele._id === v.key
                                );
                                let options: IDropdownOption[] = [
                                  // { key: "none", text: "Select a Floor" },
                                ];
                                if (datacenter) {
                                  const floorByBuilding: {
                                    [Key: string]: IFloorVM[];
                                  } = datacenter.floors.reduce(
                                    (acc: any, d) => {
                                      if (acc[d.buildingId] == null) {
                                        acc[d.buildingId] = [];
                                      }
                                      let buildingName =
                                        datacenter?.buildings.find(
                                          (ele) => ele._id === d.buildingId
                                        )?.name || "";
                                      acc[d.buildingId].push({
                                        buildingId: d.buildingId,
                                        buildingName,
                                        floorId: d._id,
                                        floorName: d.name,
                                      });
                                      return acc;
                                    },
                                    {}
                                  );
                                  let temp = Object.keys(floorByBuilding);
                                  temp.forEach((d, index) => {
                                    options.push({
                                      key: d,
                                      text: floorByBuilding[d][0].buildingName,
                                      itemType: DropdownMenuItemType.Header,
                                    });
                                    floorByBuilding[d].forEach((f) => {
                                      options.push({
                                        key: f.floorId,
                                        text: f.floorName,
                                        data: { buildingName: f.buildingName },
                                      });
                                    });
                                    if (temp.length != index + 1) {
                                      options.push({
                                        key: "divider_1",
                                        text: "-",
                                        itemType: DropdownMenuItemType.Divider,
                                      });
                                    }
                                  });

                                  console.log("[options]", options);
                                }
                                setState({
                                  ...state,
                                  cctvImage: {
                                    ...values,
                                    datacenterId: v.key as string,
                                    floorId: "none",
                                  },
                                  allFloorsDropdownList: options,
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6 ms-xl6 ms-xxl6 custom-dropdown mb-30">
                          <Dropdown
                            placeholder="Select a Floor"
                            selectedKey={values.floorId}
                            // styles={{ dropdown: { width: 200 } }}
                            options={state.allFloorsDropdownList}
                            label="Floor"
                            onRenderOption={onRenderOption}
                            onRenderTitle={onRenderTitle}
                            onBlur={handleBlur}
                            errorMessage={
                              errors.floorId && touched.floorId
                                ? errors.floorId
                                : ""
                            }
                            onChange={(e, v: IDropdownOption | undefined) => {
                              if (v) {
                                setState({
                                  ...state,
                                  cctvImage: {
                                    ...values,
                                    floorId: v.key as string,
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Stack.Item>
                  <Stack.Item className="custom-textfield">
                    <TextField
                      name="description"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.description}
                      label="Description"
                      errorMessage={
                        errors.description && touched.description
                          ? errors.description
                          : ""
                      }
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <div className="ms-Grid p-0">
                      <div className="ms-Grid-row">
                        {values.imageUrl ? (
                          <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4 ms-xxl4 c-height">
                            <img
                              className="w-100"
                              src={values.imageUrl}
                              alt="log"
                            />
                            <span
                              className="img-delete-icon"
                              onClick={() => deleteImage(values.image, values)}
                            >
                              <Icon
                                path={mdiCloseCircle}
                                size={0.8}
                                className="pointer"
                                color={THEME.palette.themePrimary}
                              />
                            </span>
                          </div>
                        ) : (
                          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 custom-textfield">
                            <TextField
                              name="image"
                              type="file"
                              accept={fileUploadConfig.acceptedFileTypes}
                              onChange={(event: any) =>
                                handleFileChange(event.target.files)
                              }
                              onBlur={handleBlur}
                              //   value={values.image}
                              label="Select an image"
                              errorMessage={
                                errors.image && touched.image
                                  ? errors.image
                                  : ""
                              }
                              description={fileUploadConfig.hintText}
                              className="file-selector"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </Stack.Item>
                  <Stack.Item>
                    {/* <Toggle
                      defaultChecked={values.isForAll}
                      // onText="Enabled"
                      // offText="Disabled"
                      label='Is Common for All Customer.'
                      onChange={(e, v) => {
                        setFieldValue('isForAll', v);
                      }}
                    /> */}
                    <Checkbox
                      label="Common for All Customer in Floor"
                      checked={values.isForAll}
                      onChange={(e, v) => {
                        setFieldValue("isForAll", v);
                      }}
                    />
                  </Stack.Item>
                  {values.isForAll === false && (
                    <Stack.Item className="custom-picker">
                      <NormalPeoplePicker
                        inputProps={{
                          placeholder: "Select Customers",
                        }}
                        onResolveSuggestions={onFilterChanged}
                        selectedItems={values.customers}
                        removeButtonAriaLabel="Remove"
                        pickerSuggestionsProps={pickerSuggestionsProps}
                        onChange={(items: any) => {
                          let selectedItems: any = [];
                          items.forEach((element: any) => {
                            selectedItems.push(element.id);
                          });
                          setFieldValue("customerIds", selectedItems);
                          setFieldValue("customers", items);

                          // setState({
                          //   ...state,
                          //   // selectedItems,
                          //   // manageAssignDialog: {
                          //   //   ...state.manageAssignDialog,
                          //   // },
                          // });
                          console.log(selectedItems);
                        }}
                      />
                    </Stack.Item>
                  )}
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={wrapStackTokens}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeAddDialog()}
                        className="borderless-btn"
                      />
                      <PrimaryButton
                        type="submit"
                        text={state.cctvImage._id ? "Update" : "Add"}
                      />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
      {state.manageImageCropDialog.isOpen && (
        <ImageCropper
          data={state.manageImageCropDialog.data}
          onClose={(data?: any) => onCloseImageCropDialog(data)}
        />
      )}
    </React.Fragment>
  );
};

export default ManageCCTVImage;
